

@for (k of [pageKey]; track k) {
  <app-main-content></app-main-content>
  <app-best-offers></app-best-offers>
}
<!--<app-cart-sidebar></app-cart-sidebar>-->
